var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.handleClick}},[_c('a-icon',{staticClass:"mr-2",attrs:{"type":"appstore"}}),_vm._v(" "+_vm._s(_vm.$t('topBar.myStore'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }